import { Modal } from "../ui/modal/Modal"
import { ModalError } from "../ui/modal/ModalError"
import { msg } from "../ui/modal/utils"

import { api } from "../../services/api"
import { getCookie } from "../../helpers/cookies"
import { useQuery } from "../../hooks/useQuery"
import { Trans, useTranslation } from "react-i18next"

export const ModalEliminarBatchWrd = ({
  show,
  ids,
  setEntries,
  setBatchDelete,
}) => {
  const deleteEntry = useQuery()

  const handleDelete = async () => {
    const { url, opt } = await api.wrds.batchDelete({
      token: getCookie("jwt"),
      ids,
    })

    // ejecuto
    deleteEntry.url.current = url
    deleteEntry.opt.current = opt

    deleteEntry.run({
      onOk: () => {
        setEntries((currents) => ({
          ...currents,
          entries: currents.entries.filter((c) => !ids.includes(c.id)),
        }))
        setBatchDelete([])
        show[1](false)
      },
    })
  }

  const { t } = useTranslation()

  const modalFooter = () => {
    return (
      <>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => show[1](false)}>
          {t(`ui.btns.cancel`)}
        </button>

        <button
          type="button"
          className="btn btn-danger"
          disabled={deleteEntry.isPending}
          onClick={() => handleDelete()}>
          {deleteEntry.isPending
            ? t(`ui.btns.deleting`) + "..."
            : t(`ui.btns.yes`)}
        </button>
      </>
    )
  }

  return (
    <>
      <Modal
        id="confirmar-accion"
        show={show}
        className="darkie"
        header={<center>{t(`ui.msgs.confirm_action`)}</center>}
        body={msg(
          <Trans
            i18nKey="modals.modal_batch_delete_word.are_you_sure"
            values={{ n: ids.length }}
            components={{ b: <b /> }}
          />
        )}
        footer={modalFooter()}
      />

      {/* en caso de erro, muestro una modal */}
      {deleteEntry.res && deleteEntry.err && (
        <ModalError show={show} res={deleteEntry.res} />
      )}
    </>
  )
}
